<div *ngIf="showCustomerID" class="grid">
  <div class="col-12">
    <h3>{{ 'COMMON.CUSTOMERID' | translate }}</h3>
  </div>
  <div class="col-12">
    <input type="text" pInputText [(ngModel)]="customerID">
  </div>
</div>


<div class="grid">
  <div class="col-12">
    <h3>{{ 'COMMON.USERID' | translate }}</h3>
  </div>
  <div class="col-12">
    <input type="text" pInputText [(ngModel)]="userID">
  </div>
</div>


<div class="grid">
  <div class="col-12">
    <h3>{{ 'FORGOTTEN.PASSWORD_COMPONENT.LABEL_EMAIL' | translate }}</h3>
  </div>
  <div class="col-12">
    <input type="text" pInputText [(ngModel)]="email">
  </div>
</div>


<div class="grid">
  <div class="col-12 center">
    <button pButton type="button" [icon]="'fa fa-key'" [label]="'FORGOTTEN.PASSWORD_COMPONENT.REINIT_BUTTON' | translate"
            [disabled]="!formIsComplete()" (click)="resetPassword()" class="p-button-warning"></button>
  </div>
</div>

<div class="grid">
  <div *ngIf="resetPasswordFail" class="error col-12">
    <p>{{errorMessage}}</p>
  </div>
  <div *ngIf="bShowIsWsoRegisteredErrorMessage" class="error col-12">
    <p style="text-align: justify;">{{errorMessageIsWsoRegistered}}</p>
  </div>
</div>



